"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArrowDown = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ArrowDown = function ArrowDown(props) {
  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, props, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.28163 13.1795L11.2913 19.1892C11.4794 19.3788 11.7354 19.4855 12.0025 19.4855C12.2695 19.4855 12.5255 19.3788 12.7136 19.1892L18.7233 13.1795C19.1133 12.7867 19.1111 12.1522 18.7183 11.7622C18.3256 11.3722 17.691 11.3745 17.301 11.7672L13.0041 16.0842L13.0041 5.48709C13.0041 4.93391 12.5557 4.48547 12.0025 4.48547C11.4493 4.48547 11.0009 4.93391 11.0009 5.48709L11.0009 16.0842L6.70392 11.7672C6.51655 11.5761 6.26045 11.4678 5.99278 11.4667C5.72654 11.4652 5.47065 11.5697 5.28163 11.7572C5.09201 11.9453 4.98535 12.2013 4.98535 12.4684C4.98535 12.7354 5.09201 12.9914 5.28163 13.1795Z"
  }));
};

exports.ArrowDown = ArrowDown;